import createIcon from '../../createIcon';

/**
 * @component @name FiberDvr
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSAxMC41SDE5LjVWMTEuNUgxNy41VjEwLjVaTTQuNSAxMC41SDYuNVYxMy41SDQuNVYxMC41Wk0yMSAzSDNDMS44OSAzIDEgMy44OSAxIDVWMTlDMSAyMC4xIDEuODkgMjEgMyAyMUgyMUMyMi4xMSAyMSAyMyAyMC4xIDIzIDE5VjVDMjMgMy44OSAyMi4xMSAzIDIxIDNaTTggMTMuNUM4IDE0LjM1IDcuMzUgMTUgNi41IDE1SDNWOUg2LjVDNy4zNSA5IDggOS42NSA4IDEwLjVWMTMuNVpNMTIuNjIgMTVIMTEuMTJMOS4zNyA5SDEwLjg3TDExLjg3IDEyLjQzTDEyLjg3IDlIMTQuMzdMMTIuNjIgMTVaTTIxIDExLjVDMjEgMTIuMSAyMC42IDEyLjY1IDIwLjEgMTIuOUwyMSAxNUgxOS41TDE4LjY1IDEzSDE3LjVWMTVIMTZWOUgxOS41QzIwLjM1IDkgMjEgOS42NSAyMSAxMC41VjExLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FiberDvr = createIcon('FiberDvr', [
  [
    'path',
    {
      d: 'M17.5 10.5H19.5V11.5H17.5V10.5ZM4.5 10.5H6.5V13.5H4.5V10.5ZM21 3H3C1.89 3 1 3.89 1 5V19C1 20.1 1.89 21 3 21H21C22.11 21 23 20.1 23 19V5C23 3.89 22.11 3 21 3ZM8 13.5C8 14.35 7.35 15 6.5 15H3V9H6.5C7.35 9 8 9.65 8 10.5V13.5ZM12.62 15H11.12L9.37 9H10.87L11.87 12.43L12.87 9H14.37L12.62 15ZM21 11.5C21 12.1 20.6 12.65 20.1 12.9L21 15H19.5L18.65 13H17.5V15H16V9H19.5C20.35 9 21 9.65 21 10.5V11.5Z',
      key: 'ixy210',
    },
  ],
]);

export default FiberDvr;
